import { createFileRoute } from "@tanstack/react-router";
import { MysticChat } from "@/components/mystic-chat";
import { SiteHeader } from "@/components/site-header";

export const Route = createFileRoute("/_authenticated/oracle")({
  component: OraclePage,
});

function OraclePage() {
  return (
    <>
      <main className="flex-1 min-h-0 flex flex-col px-4 py-4 pb-24 md:px-6 md:py-6 md:pb-6 lg:px-10 lg:py-6 lg:pb-6">
        <div className="mx-auto flex-1 min-h-0 w-full max-w-4xl rounded-3xl border border-gold-soft bg-card/40 p-3 md:p-5 backdrop-blur flex flex-col">
          <MysticChat
            kind="oracle"
            variant="scroll"
            fortuneType="iching"
            contextTitle="THẦY BÓI LINH"
            contextBody="Hãy viết điều bạn đang băn khoăn. Thầy sẽ mở lời theo Kinh Dịch và mạch hỏi đáp huyền học."
            placeholder="Viết nỗi băn khoăn của bạn vào đây..."
            subject="Oracle"
            compact
          />
        </div>
      </main>
    </>
  );
}
